<button class="btn btn-link" (click)="handleClick()" data-bs-target="#sidenav" aria-controls="sidenav"
  aria-label="Toggle sidebar" [disabled]="!tecService.isTermsAndConditionConfirmed()">

  <div class="bar-wrapper" [class.crossed]="sidenavService.opened()">
    <div class="bar top"></div>
    <div class="bar bottom"></div>
  </div>

</button>
